<template>
  <div
    :class="$vuetify.breakpoint.mdAndUp ? 'padding-lateral' : ''"
  >
    <TituloPagina :titulo="tituloDaPagina" class="mt-6 mb-4 mt-md-4" />
    <Loading v-if="loading" />
    <v-timeline
      dense
      align-top
      class="pt-0 mb-8 pt-md-1"
    >
      <v-timeline-item
        v-for="(item, index) in acompanhar"
        :key="item.message"
        fill-dot
        small
        :class="{ 'active': index === 0 }"
      >
        <v-card
          class="px-5 py-4 grey--text text--darken-2"
          min-height="220"
          data-cy="box_item_acompanhar"
        >
          <p>
            <strong class="title">
              {{ item.date | dataFormatada('numeric', '2-digit', '2-digit') }},
            </strong><span class="grey--text text--lighten-1">
              {{ item.date | horaFormatada }}
            </span>
          </p>
          <p><strong>Status</strong> {{ item.status }}</p>
          <p><strong>{{ item.user_label }}</strong> {{ item.user_name }}</p>
          <p><strong>Motivo</strong> {{ item.category }}<br>{{ item.comments }}</p>
          <v-divider
            v-if="item.attachments.length > 0"
            :class="$vuetify.breakpoint.mdAndUp ? 'linha-divider' : ''"
            class="pb-4"
          />
          <v-row v-for="(arquivo, indexFile) in item.attachments" :key="arquivo.name" no-gutters>
            <v-icon v-if="item.attachments.length > 0" class="mr-2" small>
              fas fa-download
            </v-icon>
            <a
              :href="arquivo.url"
              class="grey--text text--darken-2 font-weight-bold text-decoration-none"
              download
            >
              Baixar anexo {{ indexFile + 1 }}
            </a>
          </v-row>

          <CardDevolucaoProduto
            v-if="mostrarBotaoDevolucao(item.status_slug, index)"
            :codigo-postagem="item.trancking_number"
          />

          <v-card-actions
            v-if="mostrarBotoes(item.status_slug, index)"
            class="pt-5 px-0"
            :class="$vuetify.breakpoint.mdAndUp ? '' : 'd-inline'"
          >
            <ConsumidorRespondeReversaoProdutor
              :status-reembolso="item.status_slug"
              :codigo-reembolso="codigoReembolso"
              :codigo-venda="codigoVenda"
              @repostaApi="gravarRetornoNoStore"
            />
          </v-card-actions>
        </v-card>
      </v-timeline-item>
    </v-timeline>

    <BtnVoltar
      v-if="$vuetify.breakpoint.smAndDown"
      :voltar-para="urlDetalheCompra"
      max-width="700px"
    />

    <v-btn
      v-if="$vuetify.breakpoint.mdAndUp && !loading"
      :to="urlDetalheCompra"
      class="mt-5"
      color="primary"
      data-cy="btn_voltar"
      outlined
      width="278"
    >
      Voltar
    </v-btn>
    <SnackBar
      :mensage="snackBar.message"
      :snackbar="snackBar.show"
      :button="true"
      :color="snackBar.color"
      :timeout="9000"
      @changeSnackBar="snackbar => snackBar.show = snackbar .visible"
    />
  </div>
</template>

<script>
import api from '@/api';
import Loading from '@/components/Loading.vue';
import TituloPagina from '@/components/TituloPagina.vue';
import CardDevolucaoProduto from '@/components/AcompanharSolicitacao/CardDevolucaoProduto.vue';
import ConsumidorRespondeReversaoProdutor from '@/components/AcompanharSolicitacao/ConsumidorRespondeReversaoProdutor.vue';
import SnackBar from '@/components/SnackBar.vue';
import BtnVoltar from '@/components/BtnVoltar.vue';

export default {
  name: 'SolicitacaoTimeline',

  components: {
    TituloPagina,
    Loading,
    CardDevolucaoProduto,
    ConsumidorRespondeReversaoProdutor,
    SnackBar,
    BtnVoltar,
  },

  props: {
    codigoReembolso: {
      type: Number,
      required: true,
    },
    codigoVenda: {
      type: Number,
      required: true,
    },

  },

  data() {
    return {
      tituloDaPagina: 'Acompanhar solicitação',
      loading: true,
      acompanhar: [],
      urlApi: '/refund-request/history/',
      snackBar: {
        message: '',
        show: false,
        color: 'success',
      },
    };
  },

  computed: {
    urlDetalheCompra() {
      const codigoVenda = parseInt(this.$route.params.codigo_venda, 10);
      return `/minhas-compras/detalhe-compra/${codigoVenda}`;
    },
  },

  created() {
    this.carregarAcompanharSolicitacao();
    this.verificarMensagemConfirmacao();
  },

  methods: {
    async carregarAcompanharSolicitacao() {
      const urlCompleta = `${this.urlApi}idRefundRequest=${this.codigoReembolso}&idOrder=${this.codigoVenda}`;
      await api.get(urlCompleta)
        .then((response) => {
          this.acompanhar = response.data;
        })
        .catch(() => {
          this.acompanhar = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    mostrarBotoes(slug, index) {
      return slug === 'aguardando-resposta-consumidor' && index === 0;
    },

    mostrarBotaoDevolucao(slug, index) {
      return slug === 'aguardando-devolucao-produto' && index === 0;
    },

    mostrarSnackBar(snackBar) {
      Object.assign(this.snackBar, snackBar);
      this.snackBar.show = true;
    },

    gravarRetornoNoStore(sucesso) {
      this.$store.dispatch('setConcordouComVendedor', sucesso);
    },

    verificarMensagemConfirmacao() {
      if (this.$store.state.concordouComVendedor !== '') {
        const status = this.$store.state.concordouComVendedor;
        const snackBar = {
          message: 'Solicitação de reembolso cancelada com sucesso.',
          timeout: 9000,
        };

        if (status === true) {
          this.mostrarSnackBar(snackBar);
        } else {
          snackBar.message = 'Tente novamente mais tarde.';
          snackBar.color = 'error';
          this.mostrarSnackBar(snackBar);
        }

        this.$store.dispatch('setConcordouComVendedor', '');
      }
    },
  },
};
</script>

<style lang="scss" scope>


</style>

<style lang="scss" scope>
@import '~@/scss/timeline.scss';

.padding-lateral { padding: 0 100px; }
</style>
